<template>
  <div
    class="third-bind"
    v-loading="thirdBindLoading"
    v-if="thirdBindLoading || thirdBindList.length > 0"
  >
    <div class="third-bind-title">第三方账号</div>
    <div
      v-for="thirdBind in thirdBindList"
      :key="thirdBind.id"
      class="third-bind-item"
    >
      <div class="third-bind-info">
        <svg-icon :icon-name="thirdBind.loginIcon" class="third-bind-icon" />
        <span>{{ thirdBind.source }}</span>
        <el-tag v-if="thirdBind.bind" size="small" type="success">
          已绑定
        </el-tag>
        <el-tag v-else size="small" type="info">未绑定</el-tag>
      </div>
      <el-button
        v-if="thirdBind.bind"
        size="small"
        type="danger"
        plain
        @click="handleUnbind(thirdBind)"
      >
        解绑
      </el-button>
      <el-button
        v-else
        size="small"
        type="primary"
        plain
        @click="handleBind(thirdBind)"
      >
        绑定
      </el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import {
  bindThirdUser,
  getBindLoginUrl,
  listBind,
  unbindThirdUser
} from '@/api/auth/thirdLogin'

const { proxy } = getCurrentInstance()
const route = useRoute()
const router = useRouter()

const thirdBindList = ref([])
const thirdBindLoading = ref(false)

/**
 * 获取第三方账号绑定信息
 */
async function getThirdBindList() {
  thirdBindLoading.value = true
  try {
    const { data } = await listBind()
    thirdBindList.value = data
  } finally {
    thirdBindLoading.value = false
  }
}

/**
 * 绑定第三方账号
 */
async function handleBind(thirdBind) {
  thirdBindLoading.value = true
  try {
    const {
      data: { url }
    } = await getBindLoginUrl(thirdBind.source)
    window.location.href = url
  } finally {
    thirdBindLoading.value = false
  }
}

/**
 * 解绑第三方账号
 */
function handleUnbind(thirdBind) {
  proxy.$modal
    .confirm('是否确认解绑【' + thirdBind.source + '】账号?')
    .then(async () => {
      await unbindThirdUser(thirdBind.source)
      proxy.$modal.msgSuccess('解绑成功')
      getThirdBindList()
    })
}

/**
 * 处理第三方账号绑定回调
 */
async function handleBindTicket() {
  const bindTicket = route.query.bindTicket
  thirdBindLoading.value = true
  try {
    await bindThirdUser(bindTicket)
    proxy.$modal.msgSuccess('绑定成功')
    await router.replace('/user/profile')
    await getThirdBindList()
  } finally {
    thirdBindLoading.value = false
  }
}

async function init() {
  if (route.query.bindTicket) {
    await handleBindTicket()
    return
  }
  await getThirdBindList()
}

init()
</script>

<style lang="scss" scoped>
.third-bind {
  margin-top: 18px;

  .third-bind-title {
    margin-bottom: 8px;
    color: #606266;
    font-size: 14px;
    font-weight: 600;
  }

  .third-bind-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 42px;
    border-top: 1px solid #f0f0f0;
  }

  .third-bind-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .third-bind-icon {
    width: 22px;
    height: 22px;
  }
}
</style>
